// HEADER

// Keyboard nav
function initKeabordNavOnHeader() {
  document.querySelectorAll('.mm-header-link').forEach(link => {
    const menuId = link.getAttribute('aria-controls');
    if (!menuId) return;
    const menu = document.getElementById(menuId);
  
    // initialiser tous les enfants non focusables
    const focusables = menu.querySelectorAll('a, button, input, textarea, select');
    focusables.forEach(el => el.tabIndex = -1);
  
    const toggleMenu = (open) => {
      link.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      menu.setAttribute('aria-hidden', String(!open));
      focusables.forEach(el => {
        el.tabIndex = open ? 0 : -1;
      });
    };
  
    link.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = link.getAttribute('aria-expanded') === 'true';
        toggleMenu(!expanded);
        if (!expanded) {
          focusables[0]?.focus();
        } else {
          link.focus();
        }
      }
      if (e.key === 'Escape') {
        toggleMenu(false);
        link.focus();
      }
    });
  
    menu.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        toggleMenu(false);
        link.focus();
        return;
      }
      if (e.key !== 'Tab') return;
  
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  });
}

// Focus Trap
function initFocusTrap(container, options = {}) {
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ];
  
  const focusableElements = container.querySelectorAll(focusableSelectors.join(', '));
  if (!focusableElements.length) return; // rien à trap

  const firstEl = focusableElements[0];
  const lastEl = focusableElements[focusableElements.length - 1];
  console.log('firstEl', firstEl)
  console.log('lastEl', lastEl)

  function trapListener(e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstEl) {
          console.log('if first')
          e.preventDefault();
          lastEl.focus();
        }
      } else { // Tab
        if (document.activeElement === lastEl) {
          console.log('if last')
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    if (e.key === 'Escape' && options.onEscape) {
      options.onEscape();
    }
  }

  container.addEventListener('keydown', trapListener);

  // focus le premier élément au démarrage
  firstEl.focus();

  return () => {
    // méthode de nettoyage : retire le listener
    container.removeEventListener('keydown', trapListener);
  };
}

// Add tabindex="-1" à tous les enfants focusables d'un élément (ex: mobile menu)
function disableTabInside(container) {
  const focusables = container.querySelectorAll(
    'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
  );
  focusables.forEach(el => el.setAttribute('tabindex', '-1'));
}

// High contrast
function mmChangeContrast(btn) {
  const isActive = document.documentElement.classList.toggle('high-contrast');
  console.log('isActive', isActive)
  btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  localStorage.setItem('contrastMode', isActive ? 'on' : 'off');
}
if (localStorage.getItem('contrastMode') === 'on') {
  document.documentElement.classList.add('high-contrast');
  document.querySelector('[onclick*="mmChangeContrast"]').setAttribute('aria-pressed', 'true');
}

// Main init
document.addEventListener("DOMContentLoaded", (event) => {
  initKeabordNavOnHeader();
  disableTabInside(document.querySelector('.mm-mobile-menu-wrapper'));
});

// Debug
document.addEventListener('focusin', e => {
  console.log('FOCUS ON:', e.target);
});

// Fonction pour gérer l'accessibilité des éléments focusables
function setTabbableInside(container, enable) {
  if (!container) return;
  
  const focusables = container.querySelectorAll(
    'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
  );
  
  focusables.forEach(el => {
    el.setAttribute('tabindex', enable ? '0' : '-1');
  });
}

function initFocusTrap(container, options = {}) {
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ];

  let lastFocused = null;

  function trapListener(e) {
    if (e.key === 'Tab') {
      lastFocused = document.activeElement;
      setTimeout(() => {
        if (!container.contains(document.activeElement)) {
          if (lastFocused) lastFocused.focus();
        }
      }, 0);
    }

    if (e.key === 'Escape' && typeof options.onEscape === 'function') {
      options.onEscape();
    }

    if (e.key === 'Enter') {
      const active = document.activeElement;
      if (active && active.hasAttribute('data-exit-focus')) {
        // On laisse l'Enter faire son travail normal,
        // puis on ferme le trap juste après
        setTimeout(() => {
          if (typeof options.onEscape === 'function') {
            container.removeEventListener('keydown', trapListener);
          }
        }, 0);
      }
    }
  }

  container.addEventListener('keydown', trapListener);

  const firstFocusable = container.querySelector(focusableSelectors.join(', '));
  if (firstFocusable) {
    firstFocusable.focus();
  }

  return () => {
    container.removeEventListener('keydown', trapListener);
  };
}

